import { render, staticRenderFns } from "./PreviousNextResourceDetailsButtons.vue?vue&type=template&id=7d32ea42&scoped=true&"
import script from "./PreviousNextResourceDetailsButtons.vue?vue&type=script&lang=ts&"
export * from "./PreviousNextResourceDetailsButtons.vue?vue&type=script&lang=ts&"
import style0 from "./PreviousNextResourceDetailsButtons.vue?vue&type=style&index=0&id=7d32ea42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d32ea42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d32ea42')) {
      api.createRecord('7d32ea42', component.options)
    } else {
      api.reload('7d32ea42', component.options)
    }
    module.hot.accept("./PreviousNextResourceDetailsButtons.vue?vue&type=template&id=7d32ea42&scoped=true&", function () {
      api.rerender('7d32ea42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/PreviousNextResourceDetailsButtons.vue"
export default component.exports